export default __webpack_public_path__ + "static/N0243-7a5ad5f72cd2259c2c4902c16bf70640.png";